export default __webpack_public_path__ + "static/media/Tim.4ed561df.jpg";